// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__+Z-E2","Small":"Spinner_Small__QmczR","Tiny":"Spinner_Tiny__cu3ls","Verysmall":"Spinner_Verysmall__taOug"};